export class Plot {
	taken: boolean;
	prebuilt: boolean;
	onlyplot: boolean;
	private plot: SVGPathElement;
	private readonly id: number;
	readonly name: string;
	private readonly excerpt: string;
	readonly imageUrl: string;
	readonly imageUrlFull: string;
	private position: DOMRect;
	private plotTooltip: HTMLDivElement;
	private readonly centerX: number;
	private readonly centerY: number;
	private plotImage: HTMLImageElement;
	private plotExcerpt: HTMLDivElement;
	private tooltips: HTMLDivElement;
	private plotInfoWrapper: HTMLDivElement;
	private svg: SVGSVGElement;
	private tables: HTMLDivElement;


	constructor(
		plot: SVGPathElement,
		svg: SVGSVGElement,
		plotInfoWrapper: HTMLDivElement,
		plotImage: HTMLImageElement,
		excerpt: HTMLDivElement,
		tables: HTMLDivElement,
		tooltips: HTMLDivElement
	) {
		this.plot = plot;
		this.svg = svg;
		this.plotInfoWrapper = plotInfoWrapper;
		this.plotImage = plotImage;
		this.plotExcerpt = excerpt;
		this.tables = tables;
		this.tooltips = tooltips;
		this.id = parseInt(plot.dataset.id);
		this.name = plot.dataset.name;
		this.excerpt = plot.dataset.excerpt;
		this.imageUrl = plot.dataset.image;
		this.imageUrlFull = plot.dataset.imageFull;
		this.position = plot.getBBox();

		this.taken = !!plot.dataset.taken;
		this.prebuilt = !!plot.dataset.prebuilt;
		this.onlyplot = !!plot.dataset.onlyplot;

		this.centerX = 100 * (this.position.x + (this.position.width / 2)) / svg.viewBox.baseVal.width;
		this.centerY = 100 * (this.position.y + (this.position.height / 2)) / svg.viewBox.baseVal.height;
	}

	init() {
		this.plot.addEventListener('mouseenter', () => {
			if (this.plot.classList.contains('selected')) {
				return;
			}

			if (!this.plotTooltip) {
				this.createTooltip();
			}

			this.tooltips.appendChild(this.plotTooltip);
			this.plotTooltip.classList.add('show');
		});

		this.plot.addEventListener('mouseleave', () => {
			if (this.plot.classList.contains('selected')) {
				return;
			}

			if (this.plotTooltip) {
				this.plotTooltip.classList.remove('show');
			}
		});

		this.plot.addEventListener('deselected', () => {
			if (this.plotTooltip) {
				this.plotTooltip.classList.remove('show');
			}
		});

		this.plot.addEventListener('mousemove', e => {
			if (this.plot.classList.contains('selected')) {
				return;
			}

			const svgPos = this.svg.getBoundingClientRect();

			if (this.plotTooltip) {
				this.plotTooltip.style.top = `calc(${100 * (e.y - svgPos.top) / svgPos.height}% - 10px)`;
				this.plotTooltip.style.left = `calc(${100 * (e.x - svgPos.left) / svgPos.width}% + 5px)`;
			}
		});
	}

	select(): number {
		document.querySelectorAll('.plot-polygon.selected').forEach(el => {
			el.classList.remove('selected');
			el.dispatchEvent(new CustomEvent('deselected'));
		});
		this.plot.classList.add('selected');
		this.plotImage.src = this.imageUrl;
		this.plotImage.alt = this.name;
		this.plotExcerpt.innerText = this.excerpt;
		this.plotInfoWrapper.classList.remove('hidden');

		for (const name of [
			'architect',
			'type',
			'area',
			'size',
			'garden',
			'location',
			'floors',
			'disposition',
			'parking',
		]) {
			this.setPlotInfo(name);
		}

		if (!this.plotTooltip) {
			this.createTooltip();
		}

		this.tooltips.appendChild(this.plotTooltip);
		this.plotTooltip.classList.add('show');
		window.scrollTo({
			top: this.plotInfoWrapper.getBoundingClientRect().top + window.scrollY - 200,
			behavior: 'smooth'
		});
		return this.id;
	}

	private createTooltip(): void {
		this.plotTooltip = document.createElement('div');
		this.plotTooltip.classList.add('tooltip');
		this.plotTooltip.innerText = this.name;
		if (this.taken) {
			this.plotTooltip.innerText += ` - Prodáno`;
		}
		this.plotTooltip.style.top = `${this.centerY}%`;
		this.plotTooltip.style.left = `${this.centerX}%`;
	}

	private setPlotInfo(name: string): void {
		const cell: HTMLTableCellElement = this.tables.querySelector(`.plot-${name}`);
		if (cell && this.plot.dataset[name] && this.plot.dataset[name] !== '') {
			const value = this.plot.dataset[name];
			if (/^\d+$/.test(value)) {
				cell.innerText = parseInt(value).toLocaleString();
			}
			else {
				cell.innerText = value;
			}

			switch (name) {
				case 'area':
				case 'garden':
				case 'size':
					cell.innerHTML += ' m<sup>2</sup>';
					break;
				case 'heatLoss':
				case 'energy':
					cell.innerText += ' kW';
			}
		}
	}
}
